import React from 'react';

import SplashPage from '../components/SplashPage/SplashPage';
import Document from '../pages/index.md';

const RouteSplashPage = () => (
  <SplashPage>
    <Document />
  </SplashPage>
);

export default RouteSplashPage;
